const findReactNativeWebView = () => window.webkit?.messageHandlers?.ReactNativeWebView || window.ReactNativeWebView;

// RN handlers are visible in every frame; only a top-level page talks to native, a framed one to its parent.
export const getReactNativeWebView = () => {
  if (typeof window === 'undefined' || window.parent !== window) return undefined;
  return findReactNativeWebView();
};

// Also true when framed, e.g. game-ui inside the web app inside the mobile shell.
export const isInsideReactNativeWebView = () => typeof window !== 'undefined' && !!findReactNativeWebView();

export const sendMessageOldFormat = (msg: any) => {
  const reactNativeWebView = getReactNativeWebView();
  if (reactNativeWebView) {
    reactNativeWebView.postMessage(msg);
    return;
  }
  window.parent.postMessage(msg, '*');
};

export const isReactNativeWebView = () => !!getReactNativeWebView();

export const sendMessage = (data: Record<string, any>) => {
  const reactNativeWebView = getReactNativeWebView();

  if (reactNativeWebView) {
    reactNativeWebView.postMessage(JSON.stringify({ data }));
    return;
  }

  window.parent.postMessage(data, '*');
};

export const useMessageSender = () => {
  return { sendMessage, sendMessageOldFormat };
};
